(function () {
  const WORKER_URL = "https://shopify-blog-counter.tnt-work.workers.dev";
  const STORAGE_PREFIX = "vb_viewed_article_";

  function hasViewedInSession(handle) {
    try {
      return sessionStorage.getItem(STORAGE_PREFIX + handle) === "1";
    } catch (e) {
      return false;
    }
  }

  function markViewedInSession(handle) {
    try {
      sessionStorage.setItem(STORAGE_PREFIX + handle, "1");
    } catch (e) { }
  }

  function formatCount(num) {
    const parsed = parseInt(num, 10);
    return isNaN(parsed) ? "0" : parsed.toLocaleString();
  }

  function updateElementsForHandle(handle, count) {
    const formatted = formatCount(count);
    const elements = document.querySelectorAll(
      `.article-view-count-value[data-article-handle="${CSS.escape(handle)}"]`
    );
    elements.forEach((el) => {
      el.textContent = formatted;
    });

    const directId = document.getElementById("article-view-count");
    if (directId && directId.getAttribute("data-article-handle") === handle) {
      directId.textContent = formatted;
    }
  }

  // Increment view count (used once per session on detail visit)
  async function incrementArticleView(handle) {
    try {
      const response = await fetch(`${WORKER_URL}/views`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          article: handle,
        }),
      });

      if (!response.ok) throw new Error(`HTTP ${response.status}`);
      const data = await response.json();
      const count =
        data.views !== undefined
          ? data.views
          : data.articles !== undefined
            ? data.articles
            : typeof data === "number"
              ? data
              : 0;

      updateElementsForHandle(handle, count);
      return count;
    } catch (err) {
      console.warn(`[ViewCounter] Failed to record view for ${handle}:`, err);
      updateElementsForHandle(handle, 0);
    }
  }

  // Read view count without incrementing (used on page refreshes & listing cards)
  async function fetchArticleView(handle) {
    try {
      const response = await fetch(
        `${WORKER_URL}/views?article=${encodeURIComponent(handle)}`
      );
      if (response.ok) {
        const data = await response.json();
        const count =
          data.views !== undefined
            ? data.views
            : data.articles !== undefined
              ? data.articles
              : typeof data === "number"
                ? data
                : 0;
        updateElementsForHandle(handle, count);
        return count;
      }
    } catch (err) {
      console.warn(`[ViewCounter] Failed to fetch view for ${handle}:`, err);
    }
  }

  // Batch fetch for listing pages
  async function fetchBatchViews(handles) {
    if (!handles.length) return;

    try {
      const response = await fetch(`${WORKER_URL}/views/batch`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          articles: handles,
        }),
      });

      if (response.ok) {
        const data = await response.json();
        if (data && data.views && typeof data.views === "object") {
          Object.keys(data.views).forEach((h) => {
            updateElementsForHandle(h, data.views[h]);
          });
          return;
        }
      }
    } catch (e) {
      // Fallback to individual fetches
    }

    // Fallback: Individual GET for each handle
    handles.forEach((handle) => {
      fetchArticleView(handle);
    });
  }

  function initViewCounters() {
    const allCountElements = document.querySelectorAll(
      ".article-view-count-value[data-article-handle]"
    );
    if (!allCountElements.length) return;

    const detailElements = document.querySelectorAll(
      '.article-view-count-value[data-is-detail="true"]'
    );
    const detailHandles = new Set();

    // 1. Process detail pages (record active visit increment ONLY ONCE per session)
    detailElements.forEach((el) => {
      const handle = el.getAttribute("data-article-handle");
      if (handle) {
        detailHandles.add(handle);
        if (!hasViewedInSession(handle)) {
          markViewedInSession(handle);
          incrementArticleView(handle);
        } else {
          // Already viewed in this session (e.g. page refresh): read-only fetch
          fetchArticleView(handle);
        }
      }
    });

    // 2. Process listing/card elements (read-only)
    const listingHandles = new Set();
    allCountElements.forEach((el) => {
      const handle = el.getAttribute("data-article-handle");
      if (handle && !detailHandles.has(handle)) {
        listingHandles.add(handle);
      }
    });

    if (listingHandles.size > 0) {
      fetchBatchViews(Array.from(listingHandles));
    }
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initViewCounters);
  } else {
    initViewCounters();
  }
})();
